import React from 'react';
import { AppBar, Toolbar, Stack, Typography } from '@mui/material';
import LanguageIcon from '@mui/icons-material/Language';
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import EmailIcon from '@mui/icons-material/Email';
import LocationPinIcon from '@mui/icons-material/LocationPin';

export default function Footer() {
  return (
    <AppBar
      position="static"
      sx={{
        background: "linear-gradient(to right, #f86254ff, #b10000ff)",
        px: { xs: 2, md: 5 },
        mt: 5,       
      }}
    >
      <Toolbar
  sx={{
    display: "flex",
    justifyContent: "space-between",
    minHeight: 60,
    flexDirection: { xs: "column", md: "row" },
    alignItems: { xs: "flex-start", md: "center" },
    gap: { xs: 1.5, md: 0 },
    py: { xs: 2, md: 0 }
  }}
>
  {/* Izquierda */}
  <Stack direction="row" spacing={1} alignItems="center">
    <LanguageIcon fontSize="small" />
    <Typography variant="body2">www.camaramadrid.es</Typography>
  </Stack>

  {/* Centro */}
  <Stack direction="row" spacing={1} alignItems="center">
    <LocalPhoneIcon fontSize="small" />
    <Typography variant="body2">915 38 35 00</Typography>
  </Stack>

  {/* Dirección */}
  <Stack direction="row" spacing={1} alignItems="center">
    <LocationPinIcon fontSize="small" />
    <Typography variant="body2">
      Pedro Salinas 11, 28043 Madrid
    </Typography>
  </Stack>

  {/* Derecha */}
  <Stack direction="row" spacing={1} alignItems="center">
    <EmailIcon fontSize="small" />
    <Typography variant="body2">
      camara@camaramadrid.es
    </Typography>
  </Stack>
</Toolbar>
    </AppBar>
  );
}